// Kept free of browser globals so the shared alert provider can use it on
// every platform.
export const SESSION_EXPIRED_MESSAGES = [
  "Session Timeout, Please Login Again.",
  "User Account Not Found"
];

export const isSessionExpiredMessage = (text: string): boolean =>
  SESSION_EXPIRED_MESSAGES.some(message => text.includes(message));
